<template>
  <span class="map-control" :title="title" @click="click">
    <img :src="icon" />
  </span>
</template>

<script>
// 地图上工具按钮
export default {
  props: {
    icon: String,
    title: String
  },
  methods: {
    click() {
      this.$emit('click');
    }
  }
};
</script>

<style lang="less" scoped>
.map-control {
  width: 26px;
  height: 26px;
  display: inline-block;
  background-color: #c8e0f5;
  border-radius: 4px;
  cursor: pointer;

  img {
    width: 26px;
    height: 26px;
    display: block;
  }
}
</style>
